<template>
    <div>
        <el-card shadow='never' style='overflow: unset' class="box-card">
            <div slot='header' v-if='showCardHeader' class='clearfix'>
                <el-row :gutter='10'>
                    <el-col :span='20'>
                        <slot name='echarts-header'></slot>
                    </el-col>
                    <el-col :span='4'>
                        <el-switch
                            v-if='showLabelSwitch'
                            v-model='showChartLabel'
                            @change='handleChangeShowLabelStatus'
                            active-text='标签'>
                        </el-switch>
                    </el-col>
                </el-row>
            </div>
            <div ref='chart' :style='{ height: height, width: width }' />
            <div>
                <slot name='echarts-bottom' />
            </div>
        </el-card>
    </div>
</template>
<script>
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart, LineChart, PieChart } from 'echarts/charts';
// 引入提示框，标题，直角坐标系组件，组件后缀都为 Component
import {
    DataZoomComponent,
    GridComponent,
    LegendComponent,
    TitleComponent,
    ToolboxComponent,
    TooltipComponent,
    TransformComponent
} from 'echarts/components';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';
import { message } from '@/utils/message';

require("echarts/lib/component/dataset")

// 注册必须的组件
echarts.use(
    [TitleComponent, TooltipComponent, GridComponent, BarChart, LineChart, PieChart, CanvasRenderer, LegendComponent, ToolboxComponent, TransformComponent, DataZoomComponent]
)

export default {
    name: 'CottonEcharts',
    props: {
        width: {
            type: String,
            default: '100%'
        },
        height: {
            type: String,
            default: '450px'
        },
        autoResize: {
            type: Boolean,
            default: true
        },
        chartOption: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            default: 'canvas'
        },
        loading: {
            type: Boolean,
            default: true
        },
        showCardHeader: {
            type: Boolean,
            default: false
        },
        showLabelSwitch: {
            type: Boolean,
            default: false
        },
        useCommonChartBox: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            chart: null,
            showChartLabel: false
        }
    },
    watch: {
        chartOption: {
            deep: true,
            handler(newVal) {
                this.setOptions(newVal)
                if (!this.loading) {
                    this.hideLoading(newVal)
                }
            }
        },
        loading: {
            deep: true,
            handler(newVal) {
                if (!newVal) {
                    this.chart.showLoading();
                } else {
                    this.hideLoading(newVal);
                }
            }
        },
        height: {
            deep: true,
            handler(newVal) {
                this.resizeHandler();
            }
        }
    },
    mounted() {
        this.setLabelSwitchValue();
        this.initChart();
        if (this.autoResize) {
            window.addEventListener('resize', this.resizeHandler)
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        if (this.autoResize) {
            window.removeEventListener('resize', this.resizeHandler)
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        resizeHandler() {
            this.chart.resize()
        },
        async setShowSeriesLabelBut() {
            if (this.chartOption.toolbox) {
                if (this.chartOption.toolbox.feature) {
                    this.chartOption.toolbox.feature.showLabel = {
                        show: true,
                        title: '自定义扩展方法1',
                        icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
                        onclick: function() {
                            alert('myToolHandler1')
                        }
                    }
                }else {
                    this.chartOption.toolbox.feature = {
                        showLabel: {
                            show: true,
                            title: '自定义扩展方法1',
                            icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
                            onclick: function() {
                                alert('myToolHandler1')
                            }
                        }
                    }
                }
            }else {
            
            }
        },
        async initChart() {
            this.chart = echarts.init(this.$refs.chart, '', {
                renderer: this.type
            })
            // await this.setShowSeriesLabelBut()
            this.chart.setOption(this.chartOption)
            this.chart.on('click', this.handleClick)
            this.chart.showLoading()
            if (this.loading) {
                this.hideLoading()
            }
        },
        handleClick(params) {
            this.$emit('click', params)
        },
        setOptions(option) {
            this.setLabelSwitchValue();
            this.clearChart();
            this.resizeHandler()
            if (this.chart) {
                this.chart.setOption(option)
            }
        },
        refresh() {
            this.setOptions(this.chartOption);
        },
        clearChart() {
            this.chart && this.chart.clear();
        },
        hideLoading() {
            if (this.loading) {
                this.chart.hideLoading();
            }
        },
        handleChangeShowLabelStatus(value) {
            let series = this.chartOption.series;
            if (!series) {
                message.warning('该图表未设置标签');
                return;
            }
            if (Array.isArray(series)) {
                series.forEach(t => {
                    let label = t.label;
                    if (!label) {
                        t.label = {
                            show: value
                        };
                    } else {
                        label.show = value;
                    }
                });
            } else {
                let label = series.label;
                if (!label) {
                    series.label = {
                        show: value
                    };
                } else {
                    label.show = value;
                }
            }
        },
        setLabelSwitchValue() {
            let series = this.chartOption.series;
            if (!series) {
                return;
            }
            if (Array.isArray(series)) {
                if (!series) {
                    return;
                }
                if (!series[0]) {
                    return;
                }
                let label = series[0].label;
                if (!label) {
                    return;
                }
                this.showChartLabel = label.show;
            } else {
                let label = series.label;
                if (!label) {
                    return;
                }
                this.showChartLabel = label.show;
            }
        }
    }
}
</script>
